/* ═══════════════════════════════════════════════════════════════
   IMPERGUEL SITE DATA - BESPOKE TECHNICAL CONSULTANCY
   Pre-Production QA Version - All images audited for accuracy
   Each image MUST match its service/project representation
═══════════════════════════════════════════════════════════════ */

// REAL IMPERGUEL IMAGES - Verified work photos
const IMPERGUEL_ASSETS = {
  // User uploads - Membrane installation work in progress
  membraneInstallation: 'https://customer-assets.emergentagent.com/job_c993711d-ac84-485e-8fd9-2445697c36fc/artifacts/nbsoh29o_WhatsApp%20Image%202026-05-13%20at%206.57.20%20PM%20%2810%29.jpeg',
  
  // Modern condominium exterior (finished building)
  modernCondominium: 'https://customer-assets.emergentagent.com/job_c993711d-ac84-485e-8fd9-2445697c36fc/artifacts/40kj15ut_WhatsApp%20Image%202026-05-13%20at%206.57.21%20PM%20%281%29.jpeg',
  
  // Flat roof waterproofing work (torch-down membrane)
  flatRoofWork: 'https://customer-assets.emergentagent.com/job_c993711d-ac84-485e-8fd9-2445697c36fc/artifacts/suxdwvxp_WhatsApp%20Image%202026-05-13%20at%206.57.21%20PM%20%2822%29.jpeg',
  
  // Traditional Portuguese stone house with terracotta roof
  villageHouse: 'https://customer-assets.emergentagent.com/job_c993711d-ac84-485e-8fd9-2445697c36fc/artifacts/ec94et7g_Telhado%20portugu%C3%AAs.png',
  
  // Hero - Portuguese slate roof at sunset (NEW - user uploaded)
  slateRoof: 'https://customer-assets.emergentagent.com/job_c993711d-ac84-485e-8fd9-2445697c36fc/artifacts/fk5sucwa_Telhado%20em%20ard%C3%B3sia%20portuguesa.png',
  
  // Urban cityscape
  cityscape: 'https://customer-assets.emergentagent.com/job_c993711d-ac84-485e-8fd9-2445697c36fc/artifacts/68j6k3uc_paisagem%20urbana%20portuguesa.png',
  
  // NEW: Seaside Condominium (Commercial Project)
  seasideCondominium: 'https://customer-assets.emergentagent.com/job_c993711d-ac84-485e-8fd9-2445697c36fc/artifacts/66wdbs0f_Condominio%20Praia.jpeg',
  
  // NEW: Factory Interior (Industrial Project)
  factoryInterior: 'https://customer-assets.emergentagent.com/job_c993711d-ac84-485e-8fd9-2445697c36fc/artifacts/k3x1fd3r_F%C3%A1brica%20Interior.jpeg',
  
  // NEW: Casa no Minho (Residential Project)
  casaMinho: 'https://customer-assets.emergentagent.com/job_c993711d-ac84-485e-8fd9-2445697c36fc/artifacts/1dwcssq9_Casa%20no%20Minho.png',
  
  // NEW: Thermal Camera Inspection (user uploaded) - for Technical Diagnostics
  thermalInspection: 'https://customer-assets.emergentagent.com/job_c993711d-ac84-485e-8fd9-2445697c36fc/artifacts/q66c9ebv_inspe%C3%A7%C3%A3o%20termogr%C3%A1fica.png',
  
  // Real work photos - Verified representations
  // workPhoto2: Roof work with buildings in background
  workPhoto2: 'https://customer-assets.emergentagent.com/job_xenodochial-leakey/artifacts/tjcthwl0_WhatsApp%20Image%202025-12-08%20at%2014.19.06.jpeg',
  // workPhoto3: SOPREMA membrane installation (commercial waterproofing)
  workPhoto3: 'https://customer-assets.emergentagent.com/job_xenodochial-leakey/artifacts/ldne9oox_WhatsApp%20Image%202025-12-08%20at%2014.26.17.jpeg',
  // workPhoto5: Building facade work
  workPhoto5: 'https://customer-assets.emergentagent.com/job_xenodochial-leakey/artifacts/nkznj6zs_WhatsApp%20Image%202025-12-08%20at%2013.58.09.jpeg',
  // Technical diagnostics - Professional inspection (no third-party logos)
  technicalInspection: 'https://customer-assets.emergentagent.com/job_xenodochial-leakey/artifacts/3p0lzwqs_WhatsApp%20Image%202025-12-08%20at%2014.19.05.jpeg',
};

// Technical stock images - PERFORMANCE OPTIMIZED (WebP, real images)
const STOCK = {
  // Thermal imaging for Technical Diagnostics - Workers with thermal inspection
  thermalCamera: 'https://images.unsplash.com/photo-1778074762033-c6595907684d?w=800&q=80&fm=webp',
  
  // Industrial warehouse aerial view - Real industrial building
  industrialWarehouse: 'https://images.unsplash.com/photo-1585118213546-41087a5f6599?w=800&q=80&fm=webp',
  
  // Industrial roof - Factory/logistics complex
  industrialRoof: 'https://images.unsplash.com/photo-1592385456792-dfef3ae5fa87?w=800&q=80&fm=webp',
  
  // Thermal insulation - Worker installing insulation
  thermalInsulation: 'https://images.unsplash.com/photo-1607400201889-565b1ee75f8e?w=800&q=80&fm=webp',
  
  // Condominium building exterior (stock)
  condominiumBuilding: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&q=80&fm=webp',
  
  // Roof workers
  roofWorkers: 'https://images.unsplash.com/photo-1634750006909-3258af95e257?w=800&q=80&fm=webp',
};

// ═══════════════════════════════════════════════════════════════
// IMAGES - Mapped with strict service/representation accuracy
// ═══════════════════════════════════════════════════════════════

export const IMAGES = {
  // Hero - Portuguese slate roof at sunset (user uploaded)
  hero: IMPERGUEL_ASSETS.slateRoof,
  
  // ═══════════════════════════════════════════════════════════════
  // SERVICES - Each with VERIFIED relevant image
  // ═══════════════════════════════════════════════════════════════
  
  // 01 Waterproofing Systems - Membrane installation (real work photo)
  waterproofing: IMPERGUEL_ASSETS.membraneInstallation,
  
  // 02 Technical Diagnostics - Thermal camera inspection (user uploaded)
  diagnostics: IMPERGUEL_ASSETS.thermalInspection,
  
  // 03 Roof Waterproofing - Real roof work
  roof: IMPERGUEL_ASSETS.workPhoto2,
  
  // 04 Thermal Insulation - Worker installing insulation (stock)
  insulation: STOCK.thermalInsulation,
  
  // 05 Commercial Projects - Modern condominium (real photo)
  commercial: IMPERGUEL_ASSETS.modernCondominium,
  
  // 06 Industrial Solutions - Warehouse (stock - awaiting real project)
  industrial: STOCK.industrialWarehouse,
  
  // ═══════════════════════════════════════════════════════════════
  // PORTFOLIO - UPDATED with new uploaded images
  // ═══════════════════════════════════════════════════════════════
  
  // Residential - Casa no Minho (uploaded image)
  portfolioResidential: IMPERGUEL_ASSETS.casaMinho,
  
  // Flat Roof Waterproofing - Torch-down membrane work ✓
  portfolioFlatRoof: IMPERGUEL_ASSETS.flatRoofWork,
  
  // Commercial Waterproofing - Seaside Condominium (uploaded image)
  portfolioCommercial: IMPERGUEL_ASSETS.seasideCondominium,
  
  // Industrial Facility - Factory Interior (uploaded image)
  portfolioIndustrial: IMPERGUEL_ASSETS.factoryInterior,
  
  // ═══════════════════════════════════════════════════════════════
  // OTHER SECTIONS
  // ═══════════════════════════════════════════════════════════════
  
  // About section - Cityscape
  about: IMPERGUEL_ASSETS.cityscape,
  
  // Knowledge Centre
  knowledge: STOCK.roofWorkers,
  
  // Background texture
  roofTexture: IMPERGUEL_ASSETS.slateRoof,
};

export const LOGO = 'https://customer-assets.emergentagent.com/job_c993711d-ac84-485e-8fd9-2445697c36fc/artifacts/z2ry6tx1_imperguel_logo_pressed_transparent%20small%202.png';

export const CONTACT = {
  email: 'pedro.gomes@imperguel.com',
  phone: '+351915220443',
  phoneDisplay: '+351 915 220 443',
  whatsapp: 'https://wa.me/351915220443',
  facebook: 'https://www.facebook.com/profile.php?id=61568859617859',
  instagram: 'https://www.instagram.com/imperguel/',
  linkedin: 'https://www.linkedin.com/company/imperguel/',
  googleMaps: 'https://www.google.com/maps/place/Imperguel/@41.4942873,-8.5063608,621m/data=!3m2!1e3!4b1!4m6!3m5!1s0x6749dd745332bd1b:0x73d1ddfdb40810b5!8m2!3d41.4942873!4d-8.5063608!16s%2Fg%2F11wq35j178!5m1!1e1?entry=ttu&g_ep=EgoyMDI2MDYyNC4wIKXMDSoASAFQAw%3D%3D',
  mapsEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2989.8!2d-8.5063608!3d41.4942873!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6749dd745332bd1b%3A0x73d1ddfdb40810b5!2sImperguel!5e0!3m2!1spt-PT!2spt!4v1',
  location: 'Vila Nova de Famalicão, Portugal',
};

// ═══════════════════════════════════════════════════════════════
// SERVICES DATA - Premium technical consultancy positioning
// ═══════════════════════════════════════════════════════════════

export const SERVICES_DATA = {
  en: [
    {
      id: '01',
      slug: 'waterproofing',
      title: 'Waterproofing',
      subtitle: 'Systems',
      description: 'Complete waterproofing solutions using premium membrane systems, liquid applications and torch-on installations for lasting structural protection.',
      features: ['Torch-on membranes', 'Liquid waterproofing', 'Foundation protection', 'Expansion joints'],
      image: 'waterproofing',
      featured: false,
    },
    {
      id: '02',
      slug: 'diagnostics',
      title: 'Technical',
      subtitle: 'Diagnostics',
      description: 'Precision diagnostics using thermal imaging cameras, moisture meters and advanced technology to identify problems before they escalate.',
      features: ['Thermal camera analysis', 'Infrared inspection', 'Moisture mapping', 'Technical reports'],
      image: 'diagnostics',
      featured: true, // KEY SERVICE
    },
    {
      id: '03',
      slug: 'roof',
      title: 'Roof',
      subtitle: 'Waterproofing',
      description: 'Specialist roof waterproofing for flat and pitched roofs with premium membranes and long-term protection warranties.',
      features: ['Flat roof systems', 'Pitched roof protection', 'Membrane installation', 'Skylight sealing'],
      image: 'roof',
      featured: false,
    },
    {
      id: '04',
      slug: 'insulation',
      title: 'Thermal',
      subtitle: 'Insulation',
      description: 'Energy-efficient insulation systems that reduce heat loss, prevent condensation and improve building comfort year-round.',
      features: ['ETICS facades', 'Internal insulation', 'Roof insulation', 'Thermal bridge correction'],
      image: 'insulation',
      featured: false,
    },
    {
      id: '05',
      slug: 'commercial',
      title: 'Commercial',
      subtitle: 'Projects',
      description: 'Tailored waterproofing and insulation for condominiums, apartment developments, office buildings and mixed-use complexes.',
      features: ['Condominiums', 'Apartment buildings', 'Office complexes', 'Retail spaces'],
      image: 'commercial',
      featured: false,
    },
    {
      id: '06',
      slug: 'industrial',
      title: 'Industrial',
      subtitle: 'Solutions',
      description: 'Heavy-duty waterproofing and insulation for warehouses, factories, logistics buildings and large-scale infrastructure.',
      features: ['Warehouse roofing', 'Factory buildings', 'Logistics centres', 'Cold storage'],
      image: 'industrial',
      featured: false,
    },
  ],
  pt: [
    {
      id: '01',
      slug: 'waterproofing',
      title: 'Sistemas de',
      subtitle: 'Impermeabilização',
      description: 'Soluções completas de impermeabilização com sistemas premium, aplicações líquidas, membranas betuminosas, membranas sintéticas, cimentícios flexíveis e poliureia para proteção estrutural duradoura.',
      features: ['Membranas betuminosas', 'Impermeabilização líquida', 'Cimentícios flexíveis', 'Membranas sintéticas', 'Poliureia'],
      image: 'waterproofing',
      featured: false,
    },
    {
      id: '02',
      slug: 'diagnostics',
      title: 'Diagnóstico',
      subtitle: 'Técnico',
      description: 'Diagnóstico de precisão com câmaras térmicas, medidores de humidade e tecnologia avançada para identificar problemas antes que se agravem.',
      features: ['Análise com câmara térmica', 'Inspeção por infravermelhos', 'Mapeamento de humidades', 'Relatórios técnicos'],
      image: 'diagnostics',
      featured: true, // SERVIÇO CHAVE
    },
    {
      id: '03',
      slug: 'roof',
      title: 'Impermeabilização de',
      subtitle: 'Coberturas',
      description: 'Impermeabilização especializada para coberturas planas e inclinadas com membranas premium e garantias de proteção de longo prazo.',
      features: ['Coberturas transitáveis', 'Coberturas não transitáveis', 'Coberturas industriais', 'Coberturas verdes'],
      image: 'roof',
      featured: false,
    },
    {
      id: '04',
      slug: 'insulation',
      title: 'Isolamento',
      subtitle: 'Térmico',
      description: 'Sistemas de isolamento energeticamente eficientes que reduzem perdas de calor, previnem condensação e melhoram o conforto durante todo o ano.',
      features: ['Fachadas ETICS', 'Isolamento interior', 'Isolamento de coberturas', 'Correção de pontes térmicas'],
      image: 'insulation',
      featured: false,
    },
    {
      id: '05',
      slug: 'commercial',
      title: 'Projetos',
      subtitle: 'Comerciais',
      description: 'Soluções à medida para condomínios, empreendimentos de apartamentos, edifícios de escritórios e complexos de uso misto.',
      features: ['Condomínios', 'Edifícios de apartamentos', 'Complexos de escritórios', 'Espaços comerciais'],
      image: 'commercial',
      featured: false,
    },
    {
      id: '06',
      slug: 'industrial',
      title: 'Soluções',
      subtitle: 'Industriais',
      description: 'Impermeabilização e isolamento de alta resistência para armazéns, fábricas, edifícios logísticos e infraestruturas de grande escala.',
      features: ['Coberturas de armazéns', 'Edifícios fabris', 'Centros logísticos', 'Câmaras frigoríficas'],
      image: 'industrial',
      featured: false,
    },
  ],
};

// ═══════════════════════════════════════════════════════════════
// PORTFOLIO DATA - AUDITED for content accuracy
// REMOVED: "Heritage Roof Restoration" (incorrect image/service mismatch)
// REMOVED: "Residential Condominium" (image showed work, not building)
// ═══════════════════════════════════════════════════════════════

export const PORTFOLIO_DATA = {
  en: {
    categories: ['All', 'Residential', 'Commercial', 'Industrial'],
    projects: [
      { 
        title: 'Minho Region Residence', 
        category: 'Residential', 
        image: 'portfolioResidential', 
        location: 'Minho, Northern Portugal',
        description: 'Traditional Portuguese residence with complete waterproofing restoration, featuring terracotta roof tiles and stone construction typical of the Minho region.'
      },
      { 
        title: 'Flat Roof Waterproofing', 
        category: 'Commercial', 
        image: 'portfolioFlatRoof', 
        location: 'Porto Region',
        description: 'Professional torch-down membrane installation on commercial flat roof, using high-performance bitumen systems for complete water protection.'
      },
      { 
        title: 'Seaside Condominium', 
        category: 'Commercial', 
        image: 'portfolioCommercial', 
        location: 'Coastal Portugal',
        description: 'Modern beachfront residential complex with comprehensive waterproofing systems designed to withstand harsh maritime conditions and salt air exposure.'
      },
      { 
        title: 'Industrial Manufacturing Facility', 
        category: 'Industrial', 
        image: 'portfolioIndustrial', 
        location: 'Famalicão',
        description: 'Large-scale industrial facility with complete interior waterproofing and thermal insulation, optimized for manufacturing environments and heavy machinery areas.'
      },
    ],
  },
  pt: {
    categories: ['Todos', 'Residencial', 'Comercial', 'Industrial'],
    projects: [
      { 
        title: 'Residência na Região do Minho', 
        category: 'Residencial', 
        image: 'portfolioResidential', 
        location: 'Minho, Norte de Portugal',
        description: 'Residência tradicional portuguesa com restauro completo de impermeabilização, apresentando telhas de terracota e construção em pedra típica da região do Minho.'
      },
      { 
        title: 'Impermeabilização de Cobertura Plana', 
        category: 'Comercial', 
        image: 'portfolioFlatRoof', 
        location: 'Região do Porto',
        description: 'Instalação profissional de membranas betuminosas em cobertura plana comercial, utilizando sistemas de elevado desempenho para garantir impermeabilização duradoura, elevada resistência e proteção total da cobertura.'
      },
      { 
        title: 'Condomínio à Beira-Mar', 
        category: 'Comercial', 
        image: 'portfolioCommercial', 
        location: 'Costa Portuguesa',
        description: 'Complexo residencial moderno à beira-mar com sistema de impermeabilização em poliureia projetada, desenvolvido para máxima durabilidade, resistência às condições marítimas e proteção estrutural de longo prazo.'
      },
      { 
        title: 'Instalação Industrial', 
        category: 'Industrial', 
        image: 'portfolioIndustrial', 
        location: 'Famalicão',
        description: 'Reabilitação de uma cobertura industrial com mais de 15 anos de utilização, executada sem qualquer interrupção da operação do cliente, utilizando sistemas líquidos de elevada qualidade e revestimentos de alto índice de refletância para melhorar significativamente o desempenho térmico da cobertura.'
      },
    ],
  },
};

// ═══════════════════════════════════════════════════════════════
// ARTICLE DATA - Knowledge Centre
// ═══════════════════════════════════════════════════════════════

export const ARTICLE_DATA = {
  en: {
    slug: '5-signs-hidden-water-infiltration',
    title: '5 Early Signs Your Property Has Hidden Water Infiltration',
    date: 'June 2025',
    readTime: '6 min read',
    category: 'Building Health',
    image: 'knowledge',
    excerpt: 'Water infiltration often goes undetected for months or even years. Here are the warning signs every property owner should recognise before small issues become structural problems.',
    content: [
      { type: 'p', text: 'Water infiltration is one of the most common and potentially devastating problems affecting buildings in Portugal. The combination of Atlantic weather systems, ageing building stock and inconsistent construction standards means that millions of properties are at risk — often without their owners realising it.' },
      { type: 'h2', text: '1. Persistent Musty Odour' },
      { type: 'p', text: 'One of the earliest and most overlooked signs of hidden water infiltration is a persistent musty smell, particularly in rooms that are below ground level, adjacent to exterior walls or beneath flat roofs. This odour is caused by mould and mildew growing in damp cavities where moisture has accumulated over time.' },
      { type: 'h2', text: '2. Discolouration and Staining' },
      { type: 'p', text: 'Yellow, brown or grey stains appearing on walls and ceilings are a clear indicator that water is migrating through the building fabric. These stains often appear distant from the actual point of entry — water can travel considerable distances along structural elements before becoming visible.' },
      { type: 'h2', text: '3. Paint Bubbling and Plaster Deterioration' },
      { type: 'p', text: 'When paint begins to bubble, crack or peel in localised areas, it usually indicates moisture trapped behind the surface. Similarly, plaster that becomes soft, powdery or separates from the wall is a strong indication of ongoing water infiltration.' },
      { type: 'h2', text: '4. Rising Damp Patterns' },
      { type: 'p', text: 'A tide mark of discolouration running horizontally along the base of interior walls is a classic sign of rising damp. This occurs when ground moisture is drawn upward through capillary action in walls that lack an effective damp-proof course.' },
      { type: 'h2', text: '5. Condensation and Black Mould' },
      { type: 'p', text: 'Excessive condensation on windows, walls or ceilings — particularly during cooler months — can indicate poor insulation and thermal bridging, which creates conditions for water infiltration and mould growth. Black mould in corners, around windows or on north-facing walls is a serious warning sign.' },
      { type: 'h2', text: 'What Should You Do?' },
      { type: 'p', text: 'If you recognise any of these signs in your property, the most important step is to arrange a professional technical survey before attempting any repairs. A qualified diagnostic assessment will identify the precise source and path of infiltration, allowing targeted and effective treatment rather than temporary fixes that address symptoms rather than causes.' },
    ],
    cta: 'If you suspect water infiltration in your property, book a technical survey with Imperguel. Our diagnostic team will identify the problem and recommend the most effective solution.',
  },
  pt: {
    slug: '5-sinais-infiltracao-agua-escondida',
    title: '5 Sinais Precoces de que o Seu Imóvel Tem Infiltrações Escondidas',
    date: 'Junho 2025',
    readTime: '6 min de leitura',
    category: 'Saúde do Edifício',
    image: 'knowledge',
    excerpt: 'As infiltrações de água passam frequentemente despercebidas durante meses ou até anos. Conheça os sinais de alerta que qualquer proprietário deve reconhecer antes que pequenos problemas se transformem em danos estruturais.',
    content: [
      { type: 'p', text: 'A infiltração de água é um dos problemas mais comuns e potencialmente devastadores que afetam os edifícios em Portugal. A combinação do clima atlântico, do parque edificado envelhecido e da inconsistência nos padrões de construção significa que milhões de propriedades estão em risco — frequentemente sem que os seus proprietários se apercebam.' },
      { type: 'h2', text: '1. Odor Persistente a Mofo' },
      { type: 'p', text: 'Um dos sinais mais precoces e frequentemente ignorados de infiltração oculta é um cheiro persistente a mofo, particularmente em divisões abaixo do nível do solo, adjacentes a paredes exteriores ou sob coberturas planas. Este odor é causado por fungos e bolores que se desenvolvem em cavidades húmidas onde a humidade se acumulou ao longo do tempo.' },
      { type: 'h2', text: '2. Descoloração e Manchas' },
      { type: 'p', text: 'Manchas amarelas, castanhas ou cinzentas que surgem nas paredes e tetos são um indicador claro de que a água está a migrar através da estrutura do edifício. Estas manchas aparecem frequentemente distantes do ponto real de entrada — a água pode percorrer distâncias consideráveis ao longo dos elementos estruturais antes de se tornar visível.' },
      { type: 'h2', text: '3. Tinta a Descascar e Deterioração do Reboco' },
      { type: 'p', text: 'Quando a tinta começa a formar bolhas, a fissurar ou a descascar em áreas localizadas, indica normalmente humidade retida por trás da superfície. Do mesmo modo, reboco que se torna mole, pulverulento ou que se separa da parede é uma indicação forte de infiltração de água em curso.' },
      { type: 'h2', text: '4. Padrões de Humidade Ascensional' },
      { type: 'p', text: 'Uma marca de descoloração horizontal ao longo da base das paredes interiores é um sinal clássico de humidade ascensional. Isto ocorre quando a humidade do solo é atraída para cima por ação capilar em paredes que carecem de uma barreira eficaz contra a humidade.' },
      { type: 'h2', text: '5. Condensação e Bolor Negro' },
      { type: 'p', text: 'Condensação excessiva em janelas, paredes ou tetos — particularmente durante os meses mais frios — pode indicar isolamento deficiente e pontes térmicas, criando condições propícias à infiltração e ao crescimento de bolores. Bolor negro nos cantos, em redor de janelas ou em paredes orientadas a norte é um sinal de alerta sério.' },
      { type: 'h2', text: 'O Que Deve Fazer?' },
      { type: 'p', text: 'Se reconhece algum destes sinais no seu imóvel, o passo mais importante é agendar uma vistoria técnica profissional antes de tentar qualquer reparação. Uma avaliação diagnóstica qualificada identificará a origem e o percurso exatos da infiltração, permitindo um tratamento direcionado e eficaz em vez de soluções temporárias que tratam os sintomas e não as causas.' },
    ],
    cta: 'Se suspeita de infiltrações no seu imóvel, agende uma vistoria técnica com a Imperguel. A nossa equipa de diagnóstico identificará o problema e recomendará a solução mais eficaz.',
  },
};
